// extracted by mini-css-extract-plugin
export default {"textGreen":"NYPp_Rmg6DHnPcBGphWw","textRed":"JjZMbHahUx18Rj0d8w74"};